'use strict';

define('features/slp/details',[
  'require',
  'jquery',
  'txt!./details.hbs',
  'lib/util/langFromUrl',

  // side effect includes
  'Handlebars',
  'lib/helpers/ifCond',
  'dropkick'
], function (
  require,
  $,
  txtTemplate,
  langFromUrl
) {
  var facebook; // added as external dependency, below
  var __tmplDetails = Handlebars.compile(txtTemplate);
  var __isSpanish = langFromUrl() === 'es';
  var __usedFacebook = false;

  function __fbAppId() {
    var loc = window.location.hostname;
    if (loc === 'test.national.aws.buyatoyota.com') {
      return '2120796581543392'; // BATSLP
    }
    if (loc === 'localhost') {
      return '275023526580583'; // BATRAQ_LOCAL
    }
    return '1464766693545839'; // prod
  }

  // new instance of Details created via form.js
  var Details = function (el, config) {
    this.$el = $(el);
    this.config = config;
    this.showBothContacts = this.config.showBothContacts == 'true'; // eslint-disable-line eqeqeq, BAT-4072
  };

  // load invoked via form.js
  $.extend(Details.prototype, {
    load: function () {
      var self = this;
      this.$el.html(__tmplDetails({
        formLength: this.config.formLength,
        useFB: this.config.useFB,
        showBothContacts: this.showBothContacts,
        i18n: this.config.i18n
      }));
      this.listeners();

      if (this.config.useFB) {
        this.loadFacebook()
          .then(function () {
            self.facebookInit();
          })
          .catch(function (err) { console.log('err in FB load:', err); }); // eslint-disable-line no-console
      }
    },

    loadFacebook: function () {
      return new Promise(function (resolve, reject) {
        require(['vendor/facebook/sdk'], function () {
          facebook = window.FB;
          resolve();
        }, reject);
      });
    },

    facebookInit: function () {
      var self = this;
      var $fbLogin = $('.btn-facebook-slp--login', self.$el);
      var $fbLogout = $('.btn-facebook-slp--logout', self.$el);

      $fbLogin.show();
      facebook.init({
        appId: __fbAppId(),
        version: 'v3.0',
        status: true
      });

      function userLoggedIn() {
        $fbLogout.show();
        $fbLogin.hide();
        self.facebookUserInfo();
      }

      facebook.getLoginStatus(function (res) {
        // note: always returns 'unknown' when 3rd party cookies are disabled
        if (res.status === 'connected') {
          userLoggedIn();
        }
      }, true);

      $fbLogin.click(function () {
        facebook.login(function () {}, { scope: 'email, user_location' });
      });

      $fbLogout.click(function () {
        facebook.logout();
      });

      facebook.Event.subscribe('auth.login', function () {
        userLoggedIn();
      });

      facebook.Event.subscribe('auth.logout', function () {
        self.facebookClear();
        $fbLogout.hide();
        $fbLogin.show();
      });
    },

    facebookUserInfo: function () {
      var self = this;
      facebook.api('me', { fields: ['first_name', 'last_name', 'email', 'location'] }, function (res) {
        __usedFacebook = true;
        if (res.first_name) {
          $('input[name="customerFirstName"]', self.$el)
            .val(res.first_name)
            .prop('readonly', true);
        }
        if (res.last_name) {
          $('input[name="customerLastName"]', self.$el)
            .val(res.last_name)
            .prop('readonly', true);
        }
        if (res.email) {
          $('input[name="customerEmail"]', self.$el)
            .val(res.email)
            .prop('readonly', true);
        }
        // TODO: if longform & city & state, use those as well...
        if (res.location && res.location.id) {
          facebook.api('/' + res.location.id, { fields: ['location'] }, function (resLoc) {
            if (resLoc.location && resLoc.location.zip) {
              $('input[name="customerZipCode"]', self.$el)
                .val(resLoc.location.zip)
                .prop('readonly', true);
            }
          });
        }
      });
    },

    facebookClear: function () {
      __usedFacebook = false;
      $('input[name="customerFirstName"]', this.$el)
        .val('')
        .prop('readonly', false);
      $('input[name="customerLastName"]', this.$el)
        .val('')
        .prop('readonly', false);
      $('input[name="customerEmail"]', this.$el)
        .val('')
        .prop('readonly', false);
      $('input[name="customerZipCode"]', this.$el)
        .val('')
        .prop('readonly', false);
    },

    didUseFacebook: function () {
      return __usedFacebook;
    },

    listeners: function () {
      var self = this;
      // Ghetto, but moving on. // BAT-4072
      var $email = $('input[name="customerEmail"]', this.$el);
      var $phone = $('input[name="customerPhone"]', this.$el);

      $('input[name="preferedContact"]', this.$el).on('change', function () {
        var currVal = $("input[name='preferedContact']:checked", this.$el).val();
        if (currVal === 'email') {
          $email
            .attr({
              placeholder: 'Email*',
              required: 'required',
              title: __isSpanish ? 'Se requiere tu email*' : 'Email is required*'
            });
          if (!self.showBothContacts && self.config.formLength === 'short') {
            $email.show();
          }
          $phone
            .attr('placeholder', __isSpanish ? 'Teléfono' : 'Phone')
            .removeAttr('required')
            .removeAttr('title')
            .removeClass('ui-state-error');
          if (!self.showBothContacts && self.config.formLength === 'short') {
            $phone.hide();
          }
        } else {
          $phone
            .attr({
              placeholder: __isSpanish ? 'Teléfono*' : 'Phone*',
              required: 'required',
              title: __isSpanish ? 'Se requiere tu teléfono*' : 'Phone is required*'
            });
          if (!self.showBothContacts && self.config.formLength === 'short') {
            $phone.show();
          }
          $email
            .attr('placeholder', 'Email')
            .removeAttr('required')
            .removeAttr('title')
            .removeClass('ui-state-error');
          if (!self.showBothContacts && self.config.formLength === 'short') {
            $email.hide();
          }
        }
      });

      var $commentToggle = $('#leave-a-comment', this.$el);
      var $commentArea = $('textarea[name="commentArea"]', this.$el);
      if (this.config.formType === 'contact-a-dealer') {
        $commentArea.show();
        $commentToggle.attr('checked', 'checked');
      }

      $commentToggle.on('change', function () {
        $commentArea.toggle();
      });

      $('select[name="preferredLanguage"], select[name="customerState"]', this.$el).dropkick({ mobile: true });
    }
  });

  return Details;
});

